"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MARKING_TYPE", {
  enumerable: true,
  get: function get() {
    return _Label.MARKING_TYPE;
  }
});
Object.defineProperty(exports, "STYLE_TYPE", {
  enumerable: true,
  get: function get() {
    return _common.STYLE_TYPE;
  }
});
exports.TextArea = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _common = require("b2b-components/theme/components/Form/common");
var _Label = require("b2b-components/theme/components/Form/Label");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _Error = require("../../common/Error");
var _Info = require("../../common/Info");
require("./TextArea.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var TextArea = function TextArea(_ref) {
  var autoGrowWrapperRef = _ref.autoGrowWrapperRef,
    autocomplete = _ref.autocomplete,
    className = _ref.className,
    maxLength = _ref.maxLength,
    maxRowsAutoGrow = _ref.maxRowsAutoGrow,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onInput = _ref.onInput,
    refCallback = _ref.refCallback,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$hasFocus = _ref.hasFocus,
    hasFocus = _ref$hasFocus === void 0 ? false : _ref$hasFocus,
    _ref$info = _ref.info,
    info = _ref$info === void 0 ? null : _ref$info,
    _ref$isAutoGrow = _ref.isAutoGrow,
    isAutoGrow = _ref$isAutoGrow === void 0 ? false : _ref$isAutoGrow,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 2 : _ref$rows,
    _ref$markingType = _ref.markingType,
    markingType = _ref$markingType === void 0 ? _Label.MARKING_TYPE.none : _ref$markingType,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? _common.STYLE_TYPE.outlined : _ref$styleType,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      label: '',
      placeholder: '',
      required: '*',
      optional: '(optional)'
    } : _ref$text,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  var Error = TextArea.Error,
    Info = TextArea.Info,
    Label = TextArea.Label;
  var id = (0, _key.generateUnique)();
  var rootClassName = (0, _classnames["default"])('cds-Form-Input', "cds-Form-Input--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType)), {
    'cds-Form-Input--Error': error
  }, className);
  var labelClassName = (0, _classnames["default"])('cds-Form-Label', 'cds-TextArea-Label', {
    'cds-TextArea-Label--Top': styleType === _common.STYLE_TYPE.underlinedFloatingLabel && (hasFocus || !!value)
  });
  var autoGrowWrapperClassName = (0, _classnames["default"])('cds-Form-AutoGrowWrapper', (0, _defineProperty2["default"])({}, "cds-Form-AutoGrowWrapper--maxRows".concat(maxRowsAutoGrow || ''), maxRowsAutoGrow));
  var renderTextArea = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("textarea", {
      autoComplete: autocomplete,
      className: "cds-TextArea",
      id: id,
      disabled: isDisabled,
      maxLength: maxLength,
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,
      onInput: onInput,
      placeholder: text.placeholder,
      ref: function ref(input) {
        return input && (refCallback === null || refCallback === void 0 ? void 0 : refCallback(input));
      },
      rows: rows,
      value: value
    });
  }, [autocomplete, id, isDisabled, maxLength, onBlur, onChange, onFocus, onInput, refCallback, rows, text.placeholder, value]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, text.label && /*#__PURE__*/_react["default"].createElement(Label, {
    markingType: markingType,
    text: text,
    className: labelClassName,
    htmlFor: id
  }, text.label), isAutoGrow && /*#__PURE__*/_react["default"].createElement("div", {
    className: autoGrowWrapperClassName,
    ref: autoGrowWrapperRef
  }, renderTextArea), !isAutoGrow && renderTextArea, error && /*#__PURE__*/_react["default"].createElement(Error, null, error), info && /*#__PURE__*/_react["default"].createElement(Info, null, info)));
};
exports.TextArea = TextArea;
TextArea.Error = _Error.Error;
TextArea.Info = _Info.Info;
TextArea.Label = _Label.Label;
TextArea.config = {
  markingType: _Label.MARKING_TYPE,
  styleType: _common.STYLE_TYPE
};